import React from "react";
import { Link } from "react-router-dom";
import { Form, Input, Button } from "antd";
import { view } from "react-easy-state";

import FormIcon from "components/common/FormIcon";
import SupportNumber from "components/common/SupportNumber";

class LoginForm extends React.Component {
  render() {
    const { submitting, form } = this.props;
    const { getFieldDecorator } = form;

    const labelLogin = submitting ? " Logging in..." : "Login";

    return (
      <div className="auth-form">
        <SupportNumber />
        <Form
          onSubmit={(e) => this.props.onSubmit(e, this.props.form)}
          className="login-form form-card"
        >
          <h2>Login</h2>
          <Form.Item>
            {getFieldDecorator("email", {
              rules: [{ required: true, message: "Please enter email!" }],
            })(
              <Input
                prefix={<FormIcon type="mail" />}
                placeholder="Email"
                autoComplete="username"
              />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator("password", {
              rules: [{ required: true, message: "Please enter password!" }],
            })(
              <Input
                type="password"
                autoComplete="current-password"
                prefix={<FormIcon type="lock" />}
                placeholder="Password"
              />
            )}
          </Form.Item>
          <div className="submit-button">
            <Button
              type="primary"
              htmlType="submit"
              className="login-button"
              loading={submitting}
            >
              {labelLogin}
            </Button>
          </div>
          <p className="switch-auth-link">
            Don't have an account? <Link to="/register">Register</Link>
          </p>
          {this.props.children}
        </Form>
      </div>
    );
  }
}

LoginForm = Form.create({ name: "login-form" })(view(LoginForm));

export default LoginForm;
